import { BASE_PATH as m, BaseAPI as G, operationServerMap as p } from "../base.js";
import { DUMMY_BASE_URL as h, assertParamExists as v, createRequestFunction as R, serializeDataIfNeeded as q, setSearchParams as B, toPathString as H } from "../common.js";
import O from "axios";
var b = function(a) {
  return {
    merchantHeadquarterBusinessReportGetOverview: async (s, t = {}) => {
      v("merchantHeadquarterBusinessReportGetOverview", "merchantHeadquarterBusinessReportOverviewRequest", s);
      const o = new URL("/merchant/dc/headquarter/business-reports/overview", h);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, n = {}, u = {};
      n["Content-Type"] = "application/json", B(o, u);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...n,
        ...l,
        ...t.headers
      }, e.data = q(s, e, a), {
        url: H(o),
        options: e
      };
    },
    merchantHeadquarterBusinessReportGetRealtimeTables: async (s, t = {}) => {
      v("merchantHeadquarterBusinessReportGetRealtimeTables", "merchantHeadquarterRealtimeTablesRequest", s);
      const o = new URL("/merchant/dc/headquarter/business-reports/realtime-tables", h);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, n = {}, u = {};
      n["Content-Type"] = "application/json", B(o, u);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...n,
        ...l,
        ...t.headers
      }, e.data = q(s, e, a), {
        url: H(o),
        options: e
      };
    },
    merchantHeadquarterBusinessReportGetRevenueSummary: async (s, t = {}) => {
      v("merchantHeadquarterBusinessReportGetRevenueSummary", "merchantHeadquarterBusinessReportOverviewRequest", s);
      const o = new URL("/merchant/dc/headquarter/business-reports/revenue-summary", h);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, n = {}, u = {};
      n["Content-Type"] = "application/json", B(o, u);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...n,
        ...l,
        ...t.headers
      }, e.data = q(s, e, a), {
        url: H(o),
        options: e
      };
    }
  };
}, c = function(a) {
  const s = b(a);
  return {
    async merchantHeadquarterBusinessReportGetOverview(t, o) {
      var r, e;
      const n = await s.merchantHeadquarterBusinessReportGetOverview(t, o), u = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantHeadquarterBusinessReportControllerApi.merchantHeadquarterBusinessReportGetOverview"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (i, d) => R(n, O, m, a)(i, l || d);
    },
    async merchantHeadquarterBusinessReportGetRealtimeTables(t, o) {
      var r, e;
      const n = await s.merchantHeadquarterBusinessReportGetRealtimeTables(t, o), u = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantHeadquarterBusinessReportControllerApi.merchantHeadquarterBusinessReportGetRealtimeTables"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (i, d) => R(n, O, m, a)(i, l || d);
    },
    async merchantHeadquarterBusinessReportGetRevenueSummary(t, o) {
      var r, e;
      const n = await s.merchantHeadquarterBusinessReportGetRevenueSummary(t, o), u = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = p["MerchantHeadquarterBusinessReportControllerApi.merchantHeadquarterBusinessReportGetRevenueSummary"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (i, d) => R(n, O, m, a)(i, l || d);
    }
  };
}, w = function(a, s, t) {
  const o = c(a);
  return {
    merchantHeadquarterBusinessReportGetOverview(r, e) {
      return o.merchantHeadquarterBusinessReportGetOverview(r.merchantHeadquarterBusinessReportOverviewRequest, e).then((n) => n(t, s));
    },
    merchantHeadquarterBusinessReportGetRealtimeTables(r, e) {
      return o.merchantHeadquarterBusinessReportGetRealtimeTables(r.merchantHeadquarterRealtimeTablesRequest, e).then((n) => n(t, s));
    },
    merchantHeadquarterBusinessReportGetRevenueSummary(r, e) {
      return o.merchantHeadquarterBusinessReportGetRevenueSummary(r.merchantHeadquarterBusinessReportOverviewRequest, e).then((n) => n(t, s));
    }
  };
}, A = class extends G {
  merchantHeadquarterBusinessReportGetOverview(a, s) {
    return c(this.configuration).merchantHeadquarterBusinessReportGetOverview(a.merchantHeadquarterBusinessReportOverviewRequest, s).then((t) => t(this.axios, this.basePath));
  }
  merchantHeadquarterBusinessReportGetRealtimeTables(a, s) {
    return c(this.configuration).merchantHeadquarterBusinessReportGetRealtimeTables(a.merchantHeadquarterRealtimeTablesRequest, s).then((t) => t(this.axios, this.basePath));
  }
  merchantHeadquarterBusinessReportGetRevenueSummary(a, s) {
    return c(this.configuration).merchantHeadquarterBusinessReportGetRevenueSummary(a.merchantHeadquarterBusinessReportOverviewRequest, s).then((t) => t(this.axios, this.basePath));
  }
};
export {
  A as MerchantHeadquarterBusinessReportControllerApi,
  b as MerchantHeadquarterBusinessReportControllerApiAxiosParamCreator,
  w as MerchantHeadquarterBusinessReportControllerApiFactory,
  c as MerchantHeadquarterBusinessReportControllerApiFp
};

//# sourceMappingURL=merchant-headquarter-business-report-controller-api.js.map